__turbopack_context__.v({
  "badge": "Upcomingcategories-module__BPo5Lq__badge",
  "badgeDot": "Upcomingcategories-module__BPo5Lq__badgeDot",
  "card": "Upcomingcategories-module__BPo5Lq__card",
  "cardDesc": "Upcomingcategories-module__BPo5Lq__cardDesc",
  "cardName": "Upcomingcategories-module__BPo5Lq__cardName",
  "container": "Upcomingcategories-module__BPo5Lq__container",
  "fadeUp": "Upcomingcategories-module__BPo5Lq__fadeUp",
  "grid": "Upcomingcategories-module__BPo5Lq__grid",
  "header": "Upcomingcategories-module__BPo5Lq__header",
  "iconWrap": "Upcomingcategories-module__BPo5Lq__iconWrap",
  "pulse": "Upcomingcategories-module__BPo5Lq__pulse",
  "ribbon": "Upcomingcategories-module__BPo5Lq__ribbon",
  "section": "Upcomingcategories-module__BPo5Lq__section",
  "subtitle": "Upcomingcategories-module__BPo5Lq__subtitle",
  "title": "Upcomingcategories-module__BPo5Lq__title",
  "titleAccent": "Upcomingcategories-module__BPo5Lq__titleAccent",
  "underline": "Upcomingcategories-module__BPo5Lq__underline",
});
